
export const products = [
  {
    id: '1',
    name: 'Premium Schokolade',
    price: 27.70,
    image: 'https://public.readdy.ai/ai/img_res/dcba14c4181db57e99a61c15cf1a83e0.jpg',
    category: 'suesswaren-schokolade',
    description: 'Vollmilch 100g - Verkaufseinheit fuer Wiederverkaeufer',
    stock: 2500,
    rating: 4.5,
    reviews: 23,
    verkaufseinheit: '1 VE = 10 Stueck',
    mindestmengeStueck: 10,
    isB2B: true,
    sku: 'CHOC-PREM-001',
    stueckProVE: 10,
    veProKarton: 12,
    kartonProPalette: 40,
    preisProStueck: 2.77,
    mwstSatz: 7.7
  },
  {
    id: '2',
    name: 'BIFLAME Feuerzeug BBQ Black Fix',
    price: 143.04,
    image: 'https://readdy.ai/api/search-image?query=BBQ%20lighter%20black%20professional%20packaging%20wholesale%20B2B%20commercial%20photography%20high%20quality%20modern&width=400&height=300&seq=lighter1&orientation=landscape',
    category: 'zubehoer-artikel',
    description: 'BIFLAME Feuerzeug BBQ Black Fix - Kartonweise fuer Haendler',
    stock: 1920,
    rating: 4.3,
    reviews: 18,
    verkaufseinheit: '1 Karton = 4 VE a 24 Stueck',
    mindestmengeStueck: 96,
    isB2B: true,
    sku: 'BIFL-BBQ-002',
    stueckProVE: 24,
    veProKarton: 4,
    kartonProPalette: 20,
    preisProStueck: 1.49,
    mwstSatz: 7.7
  },
  {
    id: '3',
    name: 'Energy Drink Palette',
    price: 45.50,
    image: 'https://readdy.ai/api/search-image?query=energy%20drink%20cans%20palette%20wholesale%20B2B%20professional%20packaging%20commercial%20photography%20high%20quality%20modern&width=400&height=300&seq=energy1&orientation=landscape',
    category: 'getraenke',
    description: 'Erfrischender Energy Drink - Verkaufseinheit fuer Grosshaendler',
    stock: 1440,
    rating: 4.7,
    reviews: 45,
    verkaufseinheit: '1 VE = 12 Stueck',
    mindestmengeStueck: 12,
    isB2B: true,
    sku: 'ENRG-DRNK-003',
    stueckProVE: 12,
    veProKarton: 8,
    kartonProPalette: 24,
    preisProStueck: 3.79,
    mwstSatz: 7.7
  },
  {
    id: '4',
    name: 'Protein Riegel Display',
    price: 89.90,
    image: 'https://readdy.ai/api/search-image?query=protein%20bars%20display%20box%20wholesale%20B2B%20professional%20packaging%20commercial%20photography%20high%20quality%20modern&width=400&height=300&seq=protein1&orientation=landscape',
    category: 'gesunde-snacks',
    description: 'Hochwertiger Proteinriegel - Display fuer Verkaufsstellen',
    stock: 1200,
    rating: 4.4,
    reviews: 32,
    verkaufseinheit: '1 Karton = 3 VE a 20 Stueck',
    mindestmengeStueck: 60,
    isB2B: true,
    sku: 'PROT-RIGL-004',
    stueckProVE: 20,
    veProKarton: 3,
    kartonProPalette: 16,
    preisProStueck: 1.50,
    mwstSatz: 7.7
  },
  {
    id: '5',
    name: 'Suesswaren Mix Sortiment',
    price: 156.80,
    image: 'https://readdy.ai/api/search-image?query=mixed%20candy%20assortment%20wholesale%20packaging%20B2B%20professional%20commercial%20photography%20high%20quality%20modern&width=400&height=300&seq=candy1&orientation=landscape',
    category: 'suesswaren-schokolade',
    description: 'Gemischte Suesswaren - Sortiment fuer Einzelhaendler',
    stock: 1800,
    rating: 4.6,
    reviews: 28,
    verkaufseinheit: '1 Karton = 6 VE a 25 Stueck',
    mindestmengeStueck: 150,
    isB2B: true,
    sku: 'SWRN-MIX-005',
    stueckProVE: 25,
    veProKarton: 6,
    kartonProPalette: 12,
    preisProStueck: 1.05,
    mwstSatz: 7.7
  },
  {
    id: '6',
    name: 'Super Bock Original Bier 5.2%',
    price: 89.50,
    image: 'https://readdy.ai/api/search-image?query=super%20bock%20beer%20cans%20case%20wholesale%20B2B%20professional%20packaging%20commercial%20photography%20high%20quality%20modern%20alcohol&width=400&height=300&seq=beer1&orientation=landscape',
    category: 'alkohol',
    description: 'Super Bock Original Dosen 5.2% - 4x6er Pack - 500ml',
    stock: 480,
    rating: 4.3,
    reviews: 67,
    verkaufseinheit: '1 VE = 24 Dosen (4x6er Pack)',
    mindestmengeStueck: 24,
    isB2B: true,
    sku: 'BEER-SBOCK-006',
    stueckProVE: 24,
    veProKarton: 2,
    kartonProPalette: 30,
    preisProStueck: 3.73,
    mwstSatz: 7.7
  }
];

// Validate product data to catch malformed entries
if (typeof products !== 'undefined') {
  products.forEach((product, index) => {
    if (!product.id || !product.name || !product.price) {
      console.warn(`Product at index ${index} is missing required fields`);
    }
    // Ensure image URLs are properly formatted
    if (product.image && typeof product.image === 'string') {
      try {
        new URL(product.image);
      } catch (e) {
        console.warn(`Invalid image URL for product ${product.id}: ${product.image}`);
      }
    }
  });
}
